"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gridContext = require("./grid-context");
var _breakpoints = require("../mixins/breakpoints");
var _colors = require("../colors");
var _grid = _interopRequireDefault(require("./grid"));
function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n        width: 1020px;\n    "]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
var StyledLayout = (/*#__PURE__*/
0, _styledBase["default"])('div', {
  target: "e1qmg3iz0",
  label: "StyledLayout"
})("background-color:", _colors.common.white, ";margin:0 auto;width:100%;", _grid["default"].grid, " ", _grid["default"].separate, " ", function (props) {
  return props.twoCols ? _grid["default"].two : _grid["default"].one;
}, " ", _breakpoints.breakpointAndDesktop.xl(_templateObject()), " @media only screen and (-ms-high-contrast:none){> div:last-child{margin-right:0}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9MYXlvdXQvTGF5b3V0Q29sdW1ucy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVa0MiLCJmaWxlIjoiLi4vLi4vc3JjL0xheW91dC9MYXlvdXRDb2x1bW5zLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmltcG9ydCB7IExheW91dENvbnRleHQgfSBmcm9tICcuL2dyaWQtY29udGV4dCc7XG5cbmltcG9ydCB7IGJyZWFrcG9pbnRBbmREZXNrdG9wIH0gZnJvbSAnLi4vbWl4aW5zL2JyZWFrcG9pbnRzJztcbmltcG9ydCB7IGNvbW1vbiB9IGZyb20gJy4uL2NvbG9ycyc7XG5pbXBvcnQgR3JpZCBmcm9tICcuL2dyaWQnO1xuXG5jb25zdCBTdHlsZWRMYXlvdXQgPSBzdHlsZWQoJ2RpdicpYFxuICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29tbW9uLndoaXRlfTtcbiAgICBtYXJnaW46IDAgYXV0bztcbiAgICB3aWR0aDogMTAwJTtcblxuICAgICR7R3JpZC5ncmlkfVxuICAgICR7R3JpZC5zZXBhcmF0ZX1cblxuICAgICR7cHJvcHMgPT4gKHByb3BzLnR3b0NvbHMgPyBHcmlkLnR3byA6IEdyaWQub25lKX1cblxuICAgICR7YnJlYWtwb2ludEFuZERlc2t0b3AueGxgXG4gICAgICAgIHdpZHRoOiAxMDIwcHg7XG4gICAgYH1cblxuICAgIEBtZWRpYSBvbmx5IHNjcmVlbiBhbmQgKC1tcy1oaWdoLWNvbnRyYXN0OiBub25lKSB7XG4gICAgICA+IGRpdjpsYXN0LWNoaWxkIHtcbiAgICAgICAgbWFyZ2luLXJpZ2h0OiAwXG4gICAgICB9XG4gICAgfVxuYDtcblxuLyoqIC8vIExheW91dENvbHVtbnMgQ29tcG9uZW50XG4gKiBpbXBvcnQgeyBMYXlvdXQgfSBmcm9tICdAa2JiY29tcG9uZW50bGlicmFyeS9wcmluY2lwbGVzJztcbiAqIGNvbnN0IHsgTGF5b3V0Q29sdW1ucyB9ID0gTGF5b3V0O1xuICogKi9cbmNvbnN0IExheW91dENvbHVtbnMgPSBwcm9wcyA9PiAoXG4gIDxMYXlvdXRDb250ZXh0LlByb3ZpZGVyIHZhbHVlPXtwcm9wcy50d29Db2xzID8gMiA6IDF9PlxuICAgIDxTdHlsZWRMYXlvdXQgey4uLnByb3BzfS8+XG4gIDwvTGF5b3V0Q29udGV4dC5Qcm92aWRlcj5cbik7XG5cbkxheW91dENvbHVtbnMuZGlzcGxheU5hbWUgPSAnTGF5b3V0JztcblxuTGF5b3V0Q29sdW1ucy5kZWZhdWx0UHJvcHMgPSB7XG4gIHR3b0NvbHM6IGZhbHNlLFxufTtcblxuTGF5b3V0Q29sdW1ucy5wcm9wVHlwZXMgPSB7XG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZSxcbiAgdHdvQ29sczogUHJvcFR5cGVzLmJvb2wsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBMYXlvdXRDb2x1bW5zO1xuIl19 */"));
/** // LayoutColumns Component
 * import { Layout } from '@kbbcomponentlibrary/principles';
 * const { LayoutColumns } = Layout;
 * */

var LayoutColumns = function LayoutColumns(props) {
  return _react["default"].createElement(_gridContext.LayoutContext.Provider, {
    value: props.twoCols ? 2 : 1
  }, _react["default"].createElement(StyledLayout, props));
};
LayoutColumns.displayName = 'Layout';
LayoutColumns.defaultProps = {
  twoCols: false
};
LayoutColumns.propTypes = {
  children: _propTypes["default"].node,
  twoCols: _propTypes["default"].bool
};
var _default = LayoutColumns;
exports["default"] = _default;
LayoutColumns.__docgenInfo = {
  "description": "// LayoutColumns Component\nimport { Layout } from '@kbbcomponentlibrary/principles';\nconst { LayoutColumns } = Layout;",
  "methods": [],
  "displayName": "Layout",
  "props": {
    "twoCols": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Layout/LayoutColumns.js"] = {
    name: "LayoutColumns",
    docgenInfo: LayoutColumns.__docgenInfo,
    path: "src/Layout/LayoutColumns.js"
  };
}